import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import $ from 'jquery';
import { Modal, Button } from 'react-bootstrap';
import { formChangedAction } from 'actions';
import TabPage1 from 'components/common/TabPage1';
import loader from '../../assets/img/loader.svg'
import Moment from "moment";
import { addSchedulersAPI, emailSettingDataDetailAction, emailSettingsErrorAction, schedulersDataDetailAction, schedulersErrorAction, schedulersListAPI, updateEmailSettingDetailAPI, updateSchedulersDetailAPI, viewEmailSettingDetailAPI } from 'actions/SystemSettings/systemSettingsAction';

const tabArray = ['Schedulers', 'Create Scheduler', 'Email'];

const listColumnArray = [
  { accessor: 'sl', Header: 'S. No' },
  { accessor: 'jobName', Header: 'Job Name' },
  { accessor: 'jobType', Header: 'Job Type', },
  { accessor: 'weekDay', Header: 'Week Day' },
  // { accessor: 'monthDate', Header: 'Month Date' },
  {
    accessor: 'monthDate',
    Header: 'Month Date',
    Cell: ({ value }) => {
      return value ? Moment(value).format('DD-MM-YYYY') : '';
    },
  },
  { accessor: 'triggerTime', Header: 'Time' },
  { accessor: 'status', Header: 'Status' }
];

export const SystemSetting = () => {
  const dispatch = useDispatch();
  const [backgroundJobList, setBackgroundJobList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [searchText, setSearchText] = useState('');


  let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
  const headers = {
    Authorization: `Bearer ${JSON.parse(token).value}`
  };

  const getSchedulerList = (page, size = pageSize, searchText) => {
    const data = {
      pageNumber: page,
      pageSize: size,
      SearchText: searchText ? searchText : "",
      EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode')
    };
    setIsLoading(true);
    dispatch(
      schedulersListAPI(
        data,
        response => {
          setIsLoading(false);
          setBackgroundJobList(response.data.data.jobList);
          setTotalCount(response.data.data.totalCount);
        },
        err => {
          setIsLoading(false);
          setBackgroundJobList([]);
          console.log(err?.data.message);
        },
        headers
      )
    );
  };

  useEffect(() => {
        //     dispatch(emailSettingDataDetailAction({
        //   ...emailSettingData,
        //   encryptedEmailSettingId: "",
        // }));
    getSchedulerList(1, pageSize);
    localStorage.removeItem("EncryptedEmailSettingId");
    $('[data-rr-ui-event-key*="Create Scheduler"]').attr('disabled', true);
  }, []);
  useEffect(() => {
    viewEmailSettingAPI();
  }, []);

  const systemSettingReducer = useSelector(
    state => state.rootReducer.systemSettingReducer
  );
  var schedulerData = systemSettingReducer.schedulerData;

  var emailSettingData = systemSettingReducer.emailSettingData;

  const formChangedReducer = useSelector(
    state => state.rootReducer.formChangedReducer
  );
  var formChangedData = formChangedReducer.formChanged;

  let isFormChanged = Object.values(formChangedData).some(
    value => value === true
  );

  const [formHasError, setFormError] = useState(false);
  const [activeTabName, setActiveTabName] = useState();

  const clearBackgroundJobReducer = () => {
    dispatch(schedulersDataDetailAction(undefined));
    dispatch(schedulersErrorAction(undefined));
    dispatch(formChangedAction(undefined));
  };

  $('[data-rr-ui-event-key*="Schedulers"]')
    .off('click')
    .on('click', function () {
      let isDiscard = $('#btnDiscard').attr('isDiscard');
      if (isDiscard != 'true' && isFormChanged) {
        setModalShow(true);
        setTimeout(function () {
          $('[data-rr-ui-event-key*="' + activeTabName + '"]').trigger('click');
        }, 50);
      } else {
        // dispatch(emailSettingDataDetailAction({
        //   ...emailSettingData,
        //   encryptedEmailSettingId: "",
        // }));
        $('#btnNew').show();
        $('#btnSave').hide();
        $('#btnCancel').hide();
        $('[data-rr-ui-event-key*="Create Scheduler"]').attr('disabled', true);
        $('[data-rr-ui-event-key*="Schedulers"]').attr('disabled', false);
        $('#addSchedulerDetail').get(0).reset();

        getSchedulerList(1, pageSize);
        localStorage.removeItem('EncryptedResponseJobId');
        $('#btnDiscard').attr('isDiscard', false);
        clearBackgroundJobReducer();
      }
    });

  $('[data-rr-ui-event-key*="Create Scheduler"]')
    .off('click')
    .on('click', function () {
      setActiveTabName('Create Scheduler');
      $('#btnNew').hide();
      $('#btnSave').show();
      $('#btnCancel').show();
    });

  $('[data-rr-ui-event-key*="Email"]')
    .off('click')
    .on('click', function () {
      setActiveTabName('Email');

      viewEmailSettingAPI();
            dispatch(
        emailSettingDataDetailAction({
          ...emailSettingData,
          IsEmailSettingModule: true,
        })
      );
      $('#btnNew').hide();
      $('#btnSave').show();
      $('#btnCancel').show();
    });

  const newDetails = () => {
    $('[data-rr-ui-event-key*="Create Scheduler"]').attr('disabled', false);
    $('[data-rr-ui-event-key="Create Scheduler"]').trigger('click');
    $('#btnSave').attr('disabled', false);
    clearBackgroundJobReducer();
  };

  const cancelClick = () => {
    $('#btnExit').attr('isExit', 'false');
    if (isFormChanged) {
      setModalShow(true);
    } else {
      $('[data-rr-ui-event-key*="Schedulers"]').trigger('click');
    }
  };

  const exitModule = () => {
    $('#btnExit').attr('isExit', 'true');
    if (isFormChanged) {
      setModalShow(true);
    } else {
      window.location.href = '/dashboard';
    }
  };

  const discardChanges = () => {
    $('#btnDiscard').attr('isDiscard', 'true');
    if ($('#btnExit').attr('isExit') == 'true')
      window.location.href = '/dashboard';
    else $('[data-rr-ui-event-key*="Schedulers"]').trigger('click');

    setModalShow(false);
  };

  const jobValidation = () => {
    const jobNameErr = {};
    const jobTypeErr = {};
    const triggerTimeErr = {};
    const weekDayErr = {};
    const monthDateErr = {};
    let isValid = true;

    if (!schedulerData.jobName) {
      jobNameErr.nameEmpty = 'Enter job name';
      isValid = false;
      setFormError(true);
    }

    if (!schedulerData.jobType) {
      jobTypeErr.Empty = 'Select Type';
      isValid = false;
      setFormError(true);
    }

    if (!schedulerData.triggerTime) {
      triggerTimeErr.empty = 'Please enter time';
      isValid = false;
      setFormError(true);
    }

    if (schedulerData.jobType == "Weekly" && !schedulerData.weekDay) {
      weekDayErr.empty = 'Select day';
      isValid = false;
      setFormError(true);
    }

    if (schedulerData.jobType == "Monthly" && !schedulerData.monthDate) {
      monthDateErr.empty = 'Enter date';
      isValid = false;
      setFormError(true);
    }

    if (!isValid) {
      var errorObject = {
        jobNameErr,
        jobTypeErr,
        triggerTimeErr,
        weekDayErr,
        monthDateErr,
      };
      dispatch(schedulersErrorAction(errorObject));
    }

    return isValid;
  };

  const emailSettingValidation = () => {
    const emailTitleErr = {};
    const fromEmailErr = {};
    const fromEmailPasswordErr = {};
    const hostErr = {};
    const portErr = {};
    const bccEmailErr = {};
    let isValid = true;
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (!emailSettingData.emailTitle) {
      emailTitleErr.nameEmpty = 'Enter email title';
      isValid = false;
      setFormError(true);
    }

    if (!emailSettingData.fromEmail) {
      fromEmailErr.Empty = 'Enter from email';
      isValid = false;
      setFormError(true);
    }else if (
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailSettingData.fromEmail)
    ) {
      fromEmailErr.invalid = 'Please enter valid email address';
      isValid = false;
      setFormError(true);
    }

    if (!emailSettingData.emailPassword) {
      fromEmailPasswordErr.empty = 'Enter from email password';
      isValid = false;
      setFormError(true);
    }

    if (!emailSettingData.host) {
      hostErr.empty = 'Enter host';
      isValid = false;
      setFormError(true);
    }

    if (!emailSettingData.port) {
      portErr.empty = 'Enter port';
      isValid = false;
      setFormError(true);
    }

    if (emailSettingData.bccEmail && !emailRegex.test(emailSettingData.bccEmail)) {
      bccEmailErr.invalid = 'Please enter valid email address';
      isValid = false;
      setFormError(true);
    }
    
    if (!isValid) {
      var errorObject = {
        emailTitleErr,
        fromEmailErr,
        fromEmailPasswordErr,
        hostErr,
        portErr,
        bccEmailErr
      };
      dispatch(emailSettingsErrorAction(errorObject));
    }

    return isValid;
  };

  const addSchedulerDetail = async () => {
    if (jobValidation()) {
      const Data = {
        Name: schedulerData.jobName,
        Type: schedulerData.jobType,
        TriggerTime: schedulerData.triggerTime,
        WeekDay: schedulerData.weekDay ? schedulerData.weekDay : '',
        MonthDate: schedulerData.monthDate ? schedulerData.monthDate : null,
        ActiveStatus: schedulerData.status == "InActive" ? "InActive" : "Active",
        AddUser: localStorage.getItem('LoginUserName'),
      };
      const keys = [
        // 'JobName',
        // 'JobType',
        // 'WeekDay',
        'AddUser'
      ];
      for (const key of Object.keys(Data).filter(key => keys.includes(key))) {
        Data[key] = Data[key] ? Data[key].toUpperCase() : '';
      }
      setIsLoading(true);
      await dispatch(
        addSchedulersAPI(
          Data,
          response => {
            setIsLoading(false);
            toast.success(` ${response.data.message}`, {
              theme: 'colored',
              autoClose: 10000
            });
            updateCallback(true, response.data.data.encryptedJobId);
            setModalShow(false);
            localStorage.setItem(
              'EncryptedResponseJobId',
              response.data.data.encryptedJobId
            );
          },
          err => {
            setIsLoading(false)
            toast.error(err?.data.message, {
              theme: 'colored',
              autoClose: 10000
            });
          },
          headers
        )
      );
    }
  };

  const updateCallback = (isAddJob = false, encryptedJobId) => {
    setModalShow(false);
    dispatch(schedulersErrorAction(undefined));
    dispatch(formChangedAction(undefined));

    if (!isAddJob) {
      toast.success('Scheduler details updated successfully!', {
        theme: 'colored'
      });
    } else {
      dispatch(
        schedulersDataDetailAction({
          ...schedulerData,
          encryptedJobId: encryptedJobId
        })
      );
    }

    $('#btnSave').attr('disabled', true);
    getSchedulerList(1, pageSize);
    $('[data-rr-ui-event-key*="' + activeTabName + '"]').trigger('click');
  };

  const updateSchedulerDetail = async () => {
    if (jobValidation()) {
      const request = {
        EncryptedJobId: localStorage.getItem(
          'EncryptedResponseJobId'
        ),
        JobName: schedulerData.jobName,
        JobType: schedulerData.jobType,
        TriggerTime: schedulerData.triggerTime,
        WeekDay: schedulerData.weekDay ? schedulerData.weekDay : '',
        MonthDate: schedulerData.monthDate ? schedulerData.monthDate : null,
        Status: schedulerData.status == "InActive" ? "InActive" : "Active",
        modifyUser: localStorage.getItem('LoginUserName'),
      };

      const keys = [
        // 'JobName',
        // 'JobType',
        // 'WeekDay',
        'ModifyUser'
      ];
      for (const key of Object.keys(request).filter(key =>
        keys.includes(key)
      )) {
        request[key] = request[key] ? request[key].toUpperCase() : '';
      }
      var hasError = false;
      setIsLoading(true);
      if (formChangedData.jobUpdate) {
        await dispatch(
          updateSchedulersDetailAPI(
            request,
            res => {
              setIsLoading(false);
            },
            err => {
              setIsLoading(false)
              toast.error(err?.data.message, {
                theme: 'colored',
                autoClose: 10000
              });
              hasError = true;
            },
            headers
          )
        );
      }

      if (!hasError) {
        updateCallback();
      }
    }
  };

  const updateEmailSettingDetail = async () => {
    if (emailSettingValidation()) {
      const request = {
        EncryptedEmailSettingId: emailSettingData.encryptedEmailSettingId,
        emailTitle: emailSettingData.emailTitle,
        fromEmail: emailSettingData.fromEmail,
        fromEmailPassword: emailSettingData.emailPassword,
        bccEmail: emailSettingData.bccEmail ? emailSettingData.bccEmail : '',
        provider: emailSettingData.provider ? emailSettingData.provider : "",
        port: emailSettingData.port,
        host: emailSettingData.host,
        modifyUser: localStorage.getItem('LoginUserName'),
      };

      const keys = [
        'ModifyUser'
      ];
      for (const key of Object.keys(request).filter(key =>
        keys.includes(key)
      )) {
        request[key] = request[key] ? request[key].toUpperCase() : '';
      }
      setIsLoading(true);
      if (formChangedData.EmailSettingUpdate) {
        await dispatch(
          updateEmailSettingDetailAPI(
            request,
            res => {
              setIsLoading(false);
              toast.success('Email setting details updated successfully!', {
                theme: 'colored'
              });
              dispatch(emailSettingsErrorAction(undefined));
            },
            err => {
              setIsLoading(false)
              toast.error(err?.data.message, {
                theme: 'colored',
                autoClose: 10000
              });

            },
            headers
          )
        );
      }
    }
  };

  const viewEmailSettingAPI = async () => {
    const requestData = {
      LoginUserName: localStorage.getItem('LoginUserName'),
      EncryptedSecurityUserId: localStorage.getItem('EncryptedSecurityUserId')
    };
    await dispatch(
      viewEmailSettingDetailAPI(
        requestData,
        res => {
          var emailData = res.data.data
          dispatch(emailSettingDataDetailAction({
            ...emailSettingData,
            encryptedEmailSettingId: emailData.encryptedEmailSettingId,
            emailTitle: emailData.emailTitle,
            fromEmail: emailData.fromEmail,
            emailPassword: emailData.fromEmailPassword,
            bccEmail: emailData.bccEmail ? emailData.bccEmail : "",
            port: emailData.port,
            host: emailData.host,
            provider: emailData.provider ? emailData.provider : ""
          }));
          // localStorage.setItem("EncryptedEmailSettingId",emailData.encryptedEmailSettingId)
        },
        err => {
          console.log(err?.data.message);
        },
        headers
      )
    );
  };

  const handleClick = () => {
    if (emailSettingData.IsEmailSettingModule == true) {
      updateEmailSettingDetail();
    } else {
      if (!schedulerData.encryptedJobId) {
        addSchedulerDetail()
      } else {
        updateSchedulerDetail();
      }
    }
  }
  return (
    <>
      {isLoading ? (
        <img
          src={loader}
          alt="Loading..."
          className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
        />
      ) : null}

      {modalShow && (
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Confirmation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Do you want to save changes?</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              // onClick={
              //   !schedulerData.encryptedJobId
              //     ? addSchedulerDetail
              //     : updateSchedulerDetail
              // }
              onClick={handleClick}
            >
              Save
            </Button>
            <Button
              variant="danger"
              id="btnDiscard"
              onClick={() => discardChanges()}
            >
              Discard
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <TabPage1
        listData={backgroundJobList}
        listColumnArray={listColumnArray}
        tabArray={tabArray}
        module="Schedulers"
        saveDetails={handleClick}
        // saveDetails={
        //   schedulerData.encryptedJobId
        //     ? updateSchedulerDetail
        //     : addSchedulerDetail
        // }
        newDetails={newDetails}
        cancelClick={cancelClick}
        exitModule={exitModule}
        pageSize={pageSize}
        setPageSize={(value) => setPageSize(value)}
        searchText={searchText}
        setSearchTextValue={(value) => setSearchText(value)}
        fetchList={getSchedulerList}
        listCount={totalCount}
      />
    </>
  );
};

export default SystemSetting;
